import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FirCfcsWithQualDefService {
  constructor(private http: HttpClient) {}

  load(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=a4hz8l`;
    const body = new URLSearchParams();
    Object.keys(params || {}).forEach((k) => {
      const v = params[k];
      if (v !== undefined && v !== null) body.set(k, String(v));
    });
    body.set('process_name', "GTAPS Get CFC's with Qualified Deficits Data");
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
